import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadMonitoringIssue: IMonitoringIssueLoadActionCreator = () => {
        return {
            type: ACTION_MONITORINGISSUE_LOAD
        }
    },
    LoadMonitoringIssuesByMonitoringId: IMonitoringIssuesLoadByMonitoringIdActionCreator = (monitoringId) => {
        return {
            type: ACTION_MONITORINGISSUES_LOAD_BY_MONITORING_ID,
            monitoringId
        }
    },
    LoadMonitoringIssueById: IMonitoringIssueLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_MONITORINGISSUE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IMonitoringIssueLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IMonitoringIssueLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveMonitoringIssue: IMonitoringIssueSaveActionCreator = (formData) => {
        return {
            type: ACTION_MONITORINGISSUE_SAVE,
            formData
        }
    },
    SaveSuccess: IMonitoringIssueSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IMonitoringIssueSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateMonitoringIssue: IMonitoringIssueCreateActionCreator = (monitoringId) => {

        return {
            type: ACTION_MONITORINGISSUE_CREATE,
            monitoringId
        }
    },
    CreateSuccess: IMonitoringIssueCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_MONITORINGISSUE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IMonitoringIssueCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUE_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateMonitoringIssue: IMonitoringIssueValidateActionCreator = (formData) => {
        return {
            type: ACTION_MONITORINGISSUE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IMonitoringIssueValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IMonitoringIssueValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IMonitoringIssueClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_MONITORINGISSUE_CLEAR,
            propertiesToClear
        }
    },

    Filter: IMonitoringIssueFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_MONITORINGISSUE_FILTER,
            formFilter
        }
    };



export const
    ACTION_MONITORINGISSUE_LOAD = "ACTION_MONITORINGISSUE_LOAD",
    ACTION_MONITORINGISSUES_LOAD_BY_MONITORING_ID = "ACTION_MONITORINGISSUES_LOAD_BY_MONITORING_ID",
    ACTION_MONITORINGISSUE_LOAD_BY_ID = "ACTION_MONITORINGISSUE_LOAD_BY_ID",
    ACTION_MONITORINGISSUE_LOAD_SUCCESS = "ACTION_MONITORINGISSUE_LOAD_SUCCESS",
    ACTION_MONITORINGISSUE_LOAD_FAILURE = "ACTION_MONITORINGISSUE_LOAD_FAILURE",

    ACTION_MONITORINGISSUE_SAVE = "ACTION_MONITORINGISSUE_SAVE",
    ACTION_MONITORINGISSUE_SAVE_SUCCESS = "ACTION_MONITORINGISSUE_SAVE_SUCCESS",
    ACTION_MONITORINGISSUE_SAVE_FAILURE = "ACTION_MONITORINGISSUE_SAVE_FAILURE",

    ACTION_MONITORINGISSUE_CREATE = "ACTION_MONITORINGISSUE_CREATE",
    ACTION_MONITORINGISSUE_CREATE_SUCCESS = "ACTION_MONITORINGISSUE_CREATE_SUCCESS",
    ACTION_MONITORINGISSUE_CREATE_FAILURE = "ACTION_MONITORINGISSUE_CREATE_FAILURE",

    ACTION_MONITORINGISSUE_VALIDATE = "ACTION_MONITORINGISSUE_VALIDATE",
    ACTION_MONITORINGISSUE_VALIDATE_SUCCESS = "ACTION_MONITORINGISSUE_VALIDATE_SUCCESS",
    ACTION_MONITORINGISSUE_VALIDATE_FAILURE = "ACTION_MONITORINGISSUE_VALIDATE_FAILURE",

    ACTION_MONITORINGISSUE_CLEAR = "ACTION_MONITORINGISSUE_CLEAR",

    ACTION_MONITORINGISSUE_FILTER = "ACTION_MONITORINGISSUE_FILTER";

export interface IMonitoringIssueLoadAction {
    type: "ACTION_MONITORINGISSUE_LOAD";
}

export interface IMonitoringIssueLoadActionCreator {
    (): IMonitoringIssueLoadAction;
}

export interface IMonitoringIssueLoadSuccessAction {
    type: "ACTION_MONITORINGISSUE_LOAD_SUCCESS";
    formData: Dtos.MonitoringIssue | Dtos.MonitoringIssue[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringIssueLoadSuccessActionCreator {
    (
        formData: Dtos.MonitoringIssue | Dtos.MonitoringIssue[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringIssueLoadSuccessAction;
}

export interface IMonitoringIssueLoadFailureAction {
    type: "ACTION_MONITORINGISSUE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringIssueLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringIssueLoadFailureAction;
}

export interface IMonitoringIssuesLoadByMonitoringIdAction {
    type: "ACTION_MONITORINGISSUES_LOAD_BY_MONITORING_ID";
    monitoringId: number;
}

export interface IMonitoringIssuesLoadByMonitoringIdActionCreator {
    (monitoringId: number): IMonitoringIssuesLoadByMonitoringIdAction;
}

export interface IMonitoringIssueLoadByIdAction {
    type: "ACTION_MONITORINGISSUE_LOAD_BY_ID";
    id: number;
}

export interface IMonitoringIssueLoadByIdActionCreator {
    (id: number): IMonitoringIssueLoadByIdAction;
}


export interface IMonitoringIssueSaveAction {
    type: "ACTION_MONITORINGISSUE_SAVE";
    formData: Dtos.MonitoringIssue;

}

export interface IMonitoringIssueSaveActionCreator {
    (
        formData: Dtos.MonitoringIssue
    ): IMonitoringIssueSaveAction;
}

export interface IMonitoringIssueSaveSuccessAction {
    type: "ACTION_MONITORINGISSUE_SAVE_SUCCESS";
    formData: Dtos.MonitoringIssue;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringIssueSaveSuccessActionCreator {
    (
        formData: Dtos.MonitoringIssue,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringIssueSaveSuccessAction;
}

export interface IMonitoringIssueSaveFailureAction {
    type: "ACTION_MONITORINGISSUE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringIssueSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringIssueSaveFailureAction;
}

export interface IMonitoringIssueCreateAction {
    type: "ACTION_MONITORINGISSUE_CREATE",
    monitoringId: number
}

export interface IMonitoringIssueCreateActionCreator {
    (monitoringId: number): IMonitoringIssueCreateAction
}

export interface IMonitoringIssueCreateSuccessAction {
    type: "ACTION_MONITORINGISSUE_CREATE_SUCCESS";
    formData: Dtos.MonitoringIssue;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IMonitoringIssueCreateSuccessActionCreator {
    (
        formData: Dtos.MonitoringIssue,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IMonitoringIssueCreateSuccessAction;
}

export interface IMonitoringIssueCreateFailureAction {
    type: "ACTION_MONITORINGISSUE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringIssueCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringIssueCreateFailureAction;
}

export interface IMonitoringIssueValidateAction {
    type: "ACTION_MONITORINGISSUE_VALIDATE";
    formData: Dtos.MonitoringIssue;

}

export interface IMonitoringIssueValidateActionCreator {
    (
        formData: Dtos.MonitoringIssue
    ): IMonitoringIssueValidateAction;
}

export interface IMonitoringIssueValidateSuccessAction {
    type: "ACTION_MONITORINGISSUE_VALIDATE_SUCCESS";
    formData: Dtos.MonitoringIssue;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringIssueValidateSuccessActionCreator {
    (
        formData: Dtos.MonitoringIssue,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringIssueValidateSuccessAction;
}

export interface IMonitoringIssueValidateFailureAction {
    type: "ACTION_MONITORINGISSUE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringIssueValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringIssueValidateFailureAction;
}

export interface IMonitoringIssueClearAction {
    type: "ACTION_MONITORINGISSUE_CLEAR";
    propertiesToClear?: string[];
}

export interface IMonitoringIssueClearActionCreator {
    (propertiesToClear?: string[]): IMonitoringIssueClearAction;
}

export interface IMonitoringIssueFilterActionCreator {
    (formFilter: IFormFilter): IMonitoringIssueFilterAction;
}

export interface IMonitoringIssueFilterAction {
    type: "ACTION_MONITORINGISSUE_FILTER";
    formFilter: IFormFilter;
}

export type MonitoringIssueAction =
    IMonitoringIssueLoadAction |
    IMonitoringIssuesLoadByMonitoringIdAction |
    IMonitoringIssueLoadByIdAction |
    IMonitoringIssueLoadFailureAction |
    IMonitoringIssueLoadSuccessAction |
    IMonitoringIssueSaveAction |
    IMonitoringIssueSaveSuccessAction |
    IMonitoringIssueSaveFailureAction |
    IMonitoringIssueCreateAction |
    IMonitoringIssueCreateSuccessAction |
    IMonitoringIssueCreateFailureAction |
    IMonitoringIssueValidateAction |
    IMonitoringIssueValidateSuccessAction |
    IMonitoringIssueValidateFailureAction |
    IMonitoringIssueClearAction | 
    IMonitoringIssueFilterAction;
